import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getReservedChannels } from "./actions.js";

export const reservedChannelEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = reservedChannelEntityAdapter.getInitialState({
  totalCount: 0,
});

export const reservedChannelSlice = createSlice({
  name: "reservedChannels",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReservedChannels.fulfilled, (state, action) => {
      if (action.payload.status) {
        reservedChannelEntityAdapter.setAll(state, action.payload?.data || []);
        state.totalCount = action.payload.channelCount;
      } else {
        state.ids = [];
        state.totalCount = 0;
      }
    });
  },
});

export default reservedChannelSlice.reducer;
